import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

class InvItem extends React.Component {
  render() {
    const { id, UPC, productSizeUnit, productSize, productName, count } =
      this.props.item;

    const { filterOp, filterCount, filterName } = this.props.filter;

    // console.log("InvItem: filterOp = ", filterOp);
    // console.log("InvItem: filterCount = ", filterCount);
    // console.log("InvItem: filterName = ", filterName);
    // let display = "";
    // if (count < 0) display = " hide";

    let display = count < 0 ? " hide" : "";
    let rowHighlight = count === 0 ? " item-row-highlight" : "";

    return (
      <tr className={"inventory-row" + display + rowHighlight}>
        <td>{productName}</td>
        <td>{count}</td>
        <td>
          {productSize} {productSizeUnit}
        </td>
        <td>{UPC}</td>
        <td>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => this.props.handleDecrement(id)}
          >
            -
          </button>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={() => this.props.handleIncrement(id)}
          >
            +
          </button>

          <button
            type="button"
            className="m-2 btn btn-sm btn-outline-danger"
            onClick={() => this.props.handleDelete(id)}
          >
            x
          </button>
        </td>
      </tr>
    );
  }
}

export default InvItem;
